/* eslint-disable no-console */
const consoleError = console.error.bind(console);

export function consoleErrorHandler() {
  console.error = (errObj, ...args) => {
    if (typeof errObj === 'string' && errObj.includes('findDOMNode')) {
      return;
    }
    consoleError(errObj, ...args);
  };
}
